<template>
  <!-- 生成选手手册海报弹窗组件 -->
  <el-dialog
    title="编辑选手手册海报"
    :visible.sync="posterDialogVisible"
    width="1080px"
    append-to-body
    class="poster-manual-dialog"
    top="4vh"
    @close="closePosterDialog"
  >
    <template v-if="posterFormData">
      <div
        class="poster-toolbar poster-toolbar-text"
        v-if="selectedPosterKey && selectedPosterKey !== 'avatar'"
      >
        <span class="toolbar-label">字号：</span>
        <el-input-number
          :value="posterTextStyles[selectedPosterKey].fontSize"
          @input="setPosterStyleField(selectedPosterKey, 'fontSize', $event)"
          :min="12"
          :max="posterTextFontSizeMax"
          :step="1"
          size="small"
          style="width: 100px; vertical-align: middle;"
        ></el-input-number>
        <span class="toolbar-value">px</span>
        <span class="toolbar-label" style="margin-left: 12px;">颜色：</span>
        <input
          type="color"
          :value="posterTextStyles[selectedPosterKey].color"
          @change="onPosterColorChange(selectedPosterKey, $event.target.value)"
          class="poster-color-input"
          title="文字颜色"
        />
        <span class="toolbar-label" style="margin-left: 12px;">字重：</span>
        <el-select
          :value="getPosterBoldStage(selectedPosterKey)"
          @input="setPosterBoldStage(selectedPosterKey, $event)"
          size="mini"
          style="width: 120px;"
        >
          <el-option label="400" value="400"></el-option>
          <el-option label="500" value="500"></el-option>
          <el-option label="600" value="600"></el-option>
          <el-option label="700" value="700"></el-option>
          <el-option label="800" value="800"></el-option>
          <el-option label="900" value="900"></el-option>
        </el-select>
        <span class="toolbar-label" style="margin-left: 12px;">对齐：</span>
        <el-select
          :value="posterTextStyles[selectedPosterKey].textAlign || 'left'"
          @input="setPosterStyleField(selectedPosterKey, 'textAlign', $event)"
          size="mini"
          style="width: 110px;"
        >
          <el-option label="左对齐" value="left"></el-option>
          <el-option label="居中" value="center"></el-option>
          <el-option label="右对齐" value="right"></el-option>
        </el-select>
        <el-button
          size="mini"
          type="info"
          plain
          @click="selectedPosterKey = null"
          style="margin-left: 12px;"
        >取消选中</el-button>
        <div class="poster-edit-content-wrap">
          <span class="toolbar-label">编辑内容（可回车换行）：</span>
          <el-input
            type="textarea"
            :value="posterFormData[selectedPosterKey]"
            @input="setPosterFormField(selectedPosterKey, $event)"
            :rows="3"
            placeholder="输入内容，回车换行"
            class="poster-content-textarea"
          ></el-input>
        </div>
      </div>
      <div
        class="poster-toolbar"
        v-else-if="selectedPosterKey === 'avatar'"
      >
        <span class="toolbar-label">头像尺寸：</span>
        <el-input-number
          :value="posterTextStyles.avatar.width"
          @input="setPosterAvatarSize($event)"
          :min="60"
          :max="160"
          :step="5"
          size="small"
          style="width: 100px; vertical-align: middle;"
        ></el-input-number>
        <span class="toolbar-value">px</span>
        <span class="toolbar-label" style="margin-left: 12px;">缩放：</span>
        <el-input-number
          :value="posterTextStyles.avatar.scale"
          @input="setPosterStyleField('avatar', 'scale', $event)"
          :min="0.5"
          :max="2"
          :step="0.1"
          :precision="1"
          size="small"
          style="width: 100px; vertical-align: middle;"
        ></el-input-number>
        <span class="toolbar-value">(0.5~2倍)</span>
        <el-button
          size="mini"
          type="info"
          plain
          @click="selectedPosterKey = null"
          style="margin-left: 12px;"
        >取消选中</el-button>
      </div>
      <div
        class="poster-wrap"
        ref="posterWrapRef"
      >
        <div
          class="poster-viewport"
          :style="posterViewportStyle"
        >
          <div
            ref="posterScaleInner"
            class="poster-scale-inner"
            :style="posterScaleInnerStyle"
          >
        <div
          id="posterExportBox"
          class="poster-canvas-box"
          :style="{ width: posterWidth + 'px', height: posterHeight + 'px' }"
        >
          <img
            class="poster-bg"
            src="https://cdn.spbcn.org/spbcnappneed/user-info-back01.jpg"
            alt=""
          />
          <!-- 左上：用户头像 -->
          <div
            class="poster-item poster-avatar"
            :style="getPosterItemStyle('avatar')"
            @mousedown.prevent="startDrag($event, 'avatar')"
            @click.stop="selectedPosterKey = 'avatar'"
          >
            <div class="avatar-img" :style="getAvatarImageStyle()"></div>
          </div>
          <!-- 头像下：用户名 -->
          <div
            class="poster-item poster-text"
            :class="{ selected: selectedPosterKey === 'userName' }"
            :style="getPosterItemStyle('userName')"
            @mousedown.prevent="startDrag($event, 'userName')"
            @click.stop="selectedPosterKey = 'userName'"
          >{{ posterFormData.userName }}</div>
          <!-- 右侧：赛区 -->
          <div
            class="poster-item poster-text"
            :class="{ selected: selectedPosterKey === 'districtName' }"
            :style="getPosterItemStyle('districtName')"
            @mousedown.prevent="startDrag($event, 'districtName')"
            @click.stop="selectedPosterKey = 'districtName'"
          >{{ posterFormData.districtName }}</div>
          <!-- 年龄年级（已合并为一段文本） -->
          <div
            class="poster-item poster-text"
            :class="{ selected: selectedPosterKey === 'ageGrade' }"
            :style="getPosterItemStyle('ageGrade')"
            @mousedown.prevent="startDrag($event, 'ageGrade')"
            @click.stop="selectedPosterKey = 'ageGrade'"
          >{{ posterFormData.ageGrade }}</div>
          <!-- 学校名 -->
          <div
            class="poster-item poster-text"
            :class="{ selected: selectedPosterKey === 'schoolName' }"
            :style="getPosterItemStyle('schoolName')"
            @mousedown.prevent="startDrag($event, 'schoolName')"
            @click.stop="selectedPosterKey = 'schoolName'"
          >{{ posterFormData.schoolName }}</div>
          <!-- 国赛号码 -->
          <div
            class="poster-item poster-text poster-national-num"
            :class="{ selected: selectedPosterKey === 'NationalNum' }"
            :style="getPosterItemStyle('NationalNum')"
            @mousedown.prevent="startDrag($event, 'NationalNum')"
            @click.stop="selectedPosterKey = 'NationalNum'"
          >#{{ formatNationalNum(posterFormData.NationalNum) }}</div>
          <!-- 黄色区域左列 -->
          <div
            ref="adaptiveLeftSendWord"
            class="poster-item poster-text poster-yellow"
            :class="{ selected: selectedPosterKey === 'sendWord' }"
            :style="getPosterItemStyle('sendWord')"
            @mousedown.prevent="startDrag($event, 'sendWord')"
            @click.stop="selectedPosterKey = 'sendWord'"
          >{{ posterFormData.sendWord }}</div>
          <div
            ref="adaptiveLeftSignificance"
            class="poster-item poster-text poster-yellow"
            :class="{ selected: selectedPosterKey === 'significance' }"
            :style="getPosterItemStyle('significance')"
            @mousedown.prevent="startDrag($event, 'significance')"
            @click.stop="selectedPosterKey = 'significance'"
          >{{ posterFormData.significance }}</div>
          <div
            ref="adaptiveLeftPurposeBonus"
            class="poster-item poster-text poster-yellow"
            :class="{ selected: selectedPosterKey === 'purposeBonus' }"
            :style="getPosterItemStyle('purposeBonus')"
            @mousedown.prevent="startDrag($event, 'purposeBonus')"
            @click.stop="selectedPosterKey = 'purposeBonus'"
          >{{ posterFormData.purposeBonus }}</div>
          <div
            ref="adaptiveLeftMotto"
            class="poster-item poster-text poster-yellow"
            :class="{ selected: selectedPosterKey === 'motto' }"
            :style="getPosterItemStyle('motto')"
            @mousedown.prevent="startDrag($event, 'motto')"
            @click.stop="selectedPosterKey = 'motto'"
          >{{ posterFormData.motto }}</div>
          <!-- 黄色区域右列 -->
          <div
            class="poster-item poster-text poster-yellow"
            :class="{ selected: selectedPosterKey === 'hobbies' }"
            :style="getPosterItemStyle('hobbies')"
            @mousedown.prevent="startDrag($event, 'hobbies')"
            @click.stop="selectedPosterKey = 'hobbies'"
          >{{ posterFormData.hobbies }}</div>
          <div
            class="poster-item poster-text poster-yellow"
            :class="{ selected: selectedPosterKey === 'Favoritebooks' }"
            :style="getPosterItemStyle('Favoritebooks')"
            @mousedown.prevent="startDrag($event, 'Favoritebooks')"
            @click.stop="selectedPosterKey = 'Favoritebooks'"
          >{{ posterFormData.Favoritebooks }}</div>
        </div>
          </div>
        </div>
      </div>
    </template>
    <span slot="footer" class="dialog-footer">
      <el-button
        @click="undoPoster"
        :disabled="!posterUndoStack.length"
        title="撤销上一步操作"
      >撤 销</el-button>
      <el-button @click="posterDialogVisible = false">取 消</el-button>
      <el-button
        plain
        @click="resetPosterToInitial"
        title="恢复为准确坐标、字号、色号、粗细"
      >恢复为初始状态</el-button>
      <el-button
        plain
        @click="loadSavedPosterDefaults"
        title="应用之前保存的布局"
      >使用已保存的默认位置</el-button>
      <el-button
        type="primary"
        plain
        @click="savePosterStylesAsDefault"
      >保存为默认位置</el-button>
      <el-button
        type="primary"
        @click="downloadPosterImage"
      >保存并下载海报</el-button>
    </span>
  </el-dialog>
</template>

<script>
import html2canvas from 'html2canvas'

export default {
  name: 'CompetitorManual',
  data () {
    return {
      // 默认用户信息数据（当行数据缺失时补全）
      userInfoData: {
        // avatar: 'https://cdn.spbcn.org/spbcnappneed/2025_mokuai_tiaozhan_2025.png',
        // userName: '小蜂老师',
        // districtName: '北京赛区',
        // schoolName: '北京小学',
        // age: '12',
        // grade: '6年级',
        // NationalNum: '066',
        // sendWord: 'Hello, world!',
        // significance: '提升能力，挑战自己，提升能力，挑战自己，提升能力，挑战自己',
        // purposeBonus: '买书和玩具',
        // motto: 'different',
        // hobbies: '阅读、绘画、音乐、跳舞、唱歌、跑步',
        // Favoritebooks: '《小王子》、《红楼梦》、《西游记》'
      },
      // 选手手册海报弹窗
      posterDialogVisible: false,
      posterFormData: null,
      posterWidth: 750,
      posterHeight: 1050,
      posterTextStyles: {}, // 各文案样式 { key: { left, top, fontSize, color, bold, textAlign } }
      selectedPosterKey: null,
      posterDragState: null, // { key, startX, startY, startLeft, startTop }
      posterUndoStack: [], // 撤销栈，每项为 { styles, formData } 深拷贝
      posterUndoMaxSize: 30,
      posterRestoringUndo: false,
      /** 弹窗内预览缩放（仅视觉缩小，导出时临时还原为 1） */
      posterPreviewScale: 0.68,
      isExportingPoster: false,
      /** 左列四块文案（sendWord/significance/purposeBonus/motto）各自独立：在固定宽度内最多两行，超出则缩小字号；每项单独存 px，null 表示用 posterTextStyles.fontSize */
      posterAdaptiveFontSize: {
        sendWord: null,
        significance: null,
        purposeBonus: null,
        motto: null
      },
      posterAdaptiveFitTimer: null
    }
  },
  computed: {
    posterViewportStyle () {
      const w = this.posterWidth
      const h = this.posterHeight
      const s = this.posterPreviewScale
      if (this.isExportingPoster) {
        return {
          width: w + 'px',
          height: h + 'px',
          overflow: 'visible'
        }
      }
      return {
        width: Math.round(w * s) + 'px',
        height: Math.round(h * s) + 'px',
        overflow: 'hidden'
      }
    },
    posterScaleInnerStyle () {
      const w = this.posterWidth
      const h = this.posterHeight
      const s = this.posterPreviewScale
      const base = {
        width: w + 'px',
        height: h + 'px',
        transformOrigin: 'top left'
      }
      if (this.isExportingPoster) {
        return { ...base, transform: 'none' }
      }
      return { ...base, transform: `scale(${s})` }
    },
    // 国赛号码字号不设 36 上限，其余文案仍限制最大 36
    posterTextFontSizeMax () {
      return this.selectedPosterKey === 'NationalNum' ? 999 : 36
    }
  },
  watch: {
    posterFormData: {
      deep: true,
      handler () {
        if (!this.posterFormData || !this.posterDialogVisible) return
        this.scheduleAdaptiveLeftColumnFit()
      }
    }
  },
  methods: {
    // 对外暴露：打开海报编辑弹窗，并填充数据
    open (row) {
      if (row) {
        const details = row.sysUserDetails
        const requiredDetailKeys = [
          'age',
          'message',
          'significance',
          'winningAction',
          'difficultyWord',
          'hobby',
          'likeBook'
        ]
        const isMissing = !details || requiredDetailKeys.some((k) => {
          const v = details[k]
          return v == null || (typeof v === 'string' && v.trim() === '')
        })
        if (isMissing) {
          this.$message.warning('该用户暂未完善详细信息！')
          return
        }
      }
      // 优先使用行数据，没有则用假数据
      const data = row
        ? {
          avatar: row.oneInchPhoto || row.headImgUrl || this.userInfoData.oneInchPhoto,
          userName: row.userName || row.studentName || this.userInfoData.userName,
          districtName: row.districtName || this.userInfoData.districtName,
          grade: row.grade || this.userInfoData.grade,
          schoolName: row.schoolName || this.userInfoData.schoolName,
          age: row.sysUserDetails.age != null ? row.sysUserDetails.age : this.userInfoData.age,
          NationalNum: row.nationalnum || row.nationalNum || this.userInfoData.NationalNum,
          sendWord: row.sysUserDetails.message || this.userInfoData.message,
          significance: row.sysUserDetails.significance || this.userInfoData.significance,
          purposeBonus: row.sysUserDetails.winningAction || this.userInfoData.winningAction,
          motto: row.sysUserDetails.difficultyWord || this.userInfoData.difficultyWord,
          hobbies: row.sysUserDetails.hobby || this.userInfoData.hobby,
          Favoritebooks: row.sysUserDetails.likeBook || this.userInfoData.likeBook
        }
        : { ...this.userInfoData }
      data.ageGrade = data.ageGrade || ((data.age != null ? data.age : '') + '岁 ' + (data.grade != null ? (data.grade + '年级') : ''))
      this.posterFormData = data
      this.posterTextStyles = this.getDefaultPosterTextStyles()
      this.selectedPosterKey = null
      this.posterUndoStack = []
      this.posterAdaptiveFontSize = { sendWord: null, significance: null, purposeBonus: null, motto: null }
      this.posterDialogVisible = true
      this.$nextTick(() => this.scheduleAdaptiveLeftColumnFit())
    },
    scheduleAdaptiveLeftColumnFit () {
      if (this.posterRestoringUndo || this.isExportingPoster || !this.posterFormData) return
      clearTimeout(this.posterAdaptiveFitTimer)
      this.posterAdaptiveFitTimer = setTimeout(() => {
        this.fitAdaptiveLeftColumnTexts()
      }, 100)
    },
    // 左列四块（sendWord / significance / purposeBonus / motto）仅做自动换行，不再自动缩小字号。
    // 保留独立的 posterAdaptiveFontSize 字段以兼容历史数据，但每次统一清空，始终使用 posterTextStyles[key].fontSize。
    fitAdaptiveLeftColumnTexts () {
      const keys = ['sendWord', 'significance', 'purposeBonus', 'motto']
      keys.forEach(k => this.$set(this.posterAdaptiveFontSize, k, null))
    },
    // 单行不换行测量文本宽度（与海报上 font-size / font-family / font-weight 一致）
    measurePosterTextWidth (text, fontSizePx, fontFamily, fontWeight) {
      const span = document.createElement('span')
      span.style.cssText = [
        'position:absolute',
        'left:-9999px',
        'top:0',
        'visibility:hidden',
        'white-space:nowrap',
        `font-size:${fontSizePx}px`,
        `font-family:${fontFamily}`,
        `font-weight:${fontWeight}`,
        'padding:0',
        'margin:0',
        'border:0'
      ].join(';')
      span.textContent = text
      document.body.appendChild(span)
      const w = span.offsetWidth
      document.body.removeChild(span)
      return w
    },
    // 初始状态：坐标、字号、色号、粗细（与已调好的默认布局一致）
    getDefaultPosterTextStyles () {
      return {
        avatar: { left: 443, top: 51, fontSize: 16, width: 158, height: 230, scale: 1.2 },
        userName: { left: 537, top: 386, fontSize: 34, color: '#771d1c', bold: true, textAlign: 'center' },
        districtName: { left: 210, top: 132, fontSize: 32, color: '#ffffff', bold: true, textAlign: 'center' },
        ageGrade: { left: 210, top: 182, fontSize: 22, color: '#ffffff', bold: false, textAlign: 'center' },
        schoolName: { left: 210, top: 217, fontSize: 22, color: '#ffffff', bold: false, textAlign: 'center' },
        NationalNum: { left: 168, top: 26, fontSize: 52, color: '#771d1c', bold: false, textAlign: 'center' },
        sendWord: { left: 90, top: 374, fontSize: 19, color: '#333333', bold: false, textAlign: 'left' },
        significance: { left: 90, top: 622, fontSize: 19, color: '#333333', bold: false, textAlign: 'left' },
        purposeBonus: { left: 90, top: 714, fontSize: 19, color: '#333333', bold: false, textAlign: 'left' },
        motto: { left: 90, top: 530, fontSize: 19, color: '#333333', bold: false, textAlign: 'left' },
        hobbies: { left: 485, top: 622, fontSize: 19, color: '#333333', bold: false, textAlign: 'left' },
        Favoritebooks: { left: 485, top: 530, fontSize: 19, color: '#333333', bold: false, textAlign: 'left' }
      }
    },
    // 恢复为初始状态（当前会话内重置为准确坐标/字号/色号/粗细）
    resetPosterToInitial () {
      this.pushPosterUndoSnapshot()
      this.posterTextStyles = this.getDefaultPosterTextStyles()
      this.posterAdaptiveFontSize = { sendWord: null, significance: null, purposeBonus: null, motto: null }
      this.$message.success('已恢复为初始布局')
      this.$nextTick(() => this.scheduleAdaptiveLeftColumnFit())
    },
    // 使用已保存的默认位置（从 localStorage 加载）
    loadSavedPosterDefaults () {
      try {
        const saved = window.localStorage.getItem('posterManualDefaultStyles')
        if (!saved) {
          this.$message.info('暂无已保存的默认位置')
          return
        }
        const parsed = JSON.parse(saved)
        const builtin = this.getDefaultPosterTextStyles()
        const keys = Object.keys(builtin)
        if (!keys.every(k => parsed[k] && typeof parsed[k].left === 'number' && typeof parsed[k].top === 'number')) {
          this.$message.warning('已保存的数据不完整，请重新保存为默认位置')
          return
        }
        this.pushPosterUndoSnapshot()
        this.posterTextStyles = keys.reduce((acc, k) => {
          acc[k] = { ...builtin[k], ...parsed[k] }
          return acc
        }, {})
        this.$message.success('已应用已保存的默认位置')
        this.posterAdaptiveFontSize = { sendWord: null, significance: null, purposeBonus: null, motto: null }
        this.$nextTick(() => this.scheduleAdaptiveLeftColumnFit())
      } catch (e) {
        this.$message.error('加载失败：' + (e && e.message))
      }
    },
    pushPosterUndoSnapshot () {
      if (this.posterRestoringUndo || !this.posterFormData) return
      const snap = {
        styles: JSON.parse(JSON.stringify(this.posterTextStyles)),
        formData: JSON.parse(JSON.stringify(this.posterFormData))
      }
      this.posterUndoStack.push(snap)
      if (this.posterUndoStack.length > this.posterUndoMaxSize) this.posterUndoStack.shift()
    },
    undoPoster () {
      if (!this.posterUndoStack.length) return
      const snap = this.posterUndoStack.pop()
      this.posterRestoringUndo = true
      this.posterTextStyles = snap.styles
      this.posterFormData = snap.formData
      this.posterAdaptiveFontSize = { sendWord: null, significance: null, purposeBonus: null, motto: null }
      this.$nextTick(() => {
        this.posterRestoringUndo = false
        this.scheduleAdaptiveLeftColumnFit()
      })
    },
    setPosterStyleField (key, field, value) {
      this.pushPosterUndoSnapshot()
      if (this.posterTextStyles[key]) this.$set(this.posterTextStyles[key], field, value)
      if (
        field === 'fontSize' &&
        (key === 'sendWord' || key === 'significance' || key === 'purposeBonus' || key === 'motto')
      ) {
        this.$set(this.posterAdaptiveFontSize, key, null)
        this.$nextTick(() => this.scheduleAdaptiveLeftColumnFit())
      }
    },
    getPosterBoldStage (key) {
      const s = key && this.posterTextStyles[key]
      if (!s) return '400'
      if (s.boldStage) {
        if (s.boldStage === 'heavy') return '900'
        if (s.boldStage === 'bold') return '700'
        if (s.boldStage === 'normal') return '400'
        const n = Number(s.boldStage)
        if ([400, 500, 600, 700, 800, 900].includes(n)) return String(n)
      }
      if (s.bold) return key === 'userName' ? '900' : '700'
      return '400'
    },
    setPosterBoldStage (key, stage) {
      if (!key || !this.posterTextStyles[key]) return
      this.pushPosterUndoSnapshot()
      const n = Number(stage)
      const weight = [400, 500, 600, 700, 800, 900].includes(n) ? n : 400
      this.$set(this.posterTextStyles[key], 'boldStage', String(weight))
      // 兼容历史字段，方便旧逻辑/已保存数据继续可用
      this.$set(this.posterTextStyles[key], 'bold', weight >= 700)
    },
    setPosterFormField (field, value) {
      this.pushPosterUndoSnapshot()
      this.$set(this.posterFormData, field, value)
    },
    setPosterAvatarSize (width) {
      const avatar = this.posterTextStyles.avatar
      if (avatar) {
        const nextWidth = Number(width)
        const prevWidth = Number(avatar.width) || 1
        const prevHeight = Number(avatar.height) || 1
        if (nextWidth === prevWidth) return
        this.pushPosterUndoSnapshot()
        // 保持当前宽高比例，避免选中头像后被压成正方形
        const ratio = prevHeight / prevWidth
        const nextHeight = Math.max(1, Math.round(nextWidth * ratio))
        this.$set(avatar, 'width', nextWidth)
        this.$set(avatar, 'height', nextHeight)
      }
    },
    formatNationalNum (val) {
      const s = String(val == null ? '' : val).trim()
      if (!s) return '000'
      const onlyDigits = s.replace(/\D/g, '')
      if (!onlyDigits) return '000'
      return onlyDigits.slice(-3).padStart(3, '0')
    },
    savePosterStylesAsDefault () {
      try {
        const toSave = JSON.stringify(this.posterTextStyles)
        console.log('toSave', toSave)
        window.localStorage.setItem('posterManualDefaultStyles', toSave)
        this.$message.success('已保存为默认位置，可点击「使用已保存的默认位置」应用')
      } catch (e) {
        this.$message.error('保存失败：' + (e && e.message))
      }
    },
    getPosterItemStyle (key) {
      const s = this.posterTextStyles[key]
      if (!s) return {}
      let fontSizePx = Number(s.fontSize) || 14
      if (
        (key === 'sendWord' || key === 'significance' || key === 'purposeBonus' || key === 'motto') &&
        this.posterAdaptiveFontSize[key] != null
      ) {
        fontSizePx = Number(this.posterAdaptiveFontSize[key])
      }
      const style = {
        left: s.left + 'px',
        top: s.top + 'px',
        fontSize: fontSizePx + 'px'
      }
      // 用户名与国赛号保持中心点不变，文字变长时左右等距伸缩
      if (key === 'userName' || key === 'NationalNum') {
        style.transform = 'translateX(-50%)'
        style.letterSpacing = '2px'
      }
      // 顶部左侧信息改为按中心点排版，适配不同文字长度
      if (key === 'districtName' || key === 'ageGrade' || key === 'schoolName') {
        style.transform = 'translateX(-50%)'
        style.textAlign = s.textAlign || 'center'
      }
      if (key === 'hobbies' || key === 'Favoritebooks') {
        style.maxWidth = '200px'
        style.wordBreak = 'break-word'
        style.lineHeight = '1.25'
        style.whiteSpace = 'pre-line'
      }
      if (key === 'sendWord' || key === 'significance' || key === 'purposeBonus' || key === 'motto') {
        style.maxWidth = '300px'
        style.width = '300px'
        style.boxSizing = 'border-box'
        style.lineHeight = '1.25'
        style.wordBreak = 'break-word'
        style.whiteSpace = 'pre-line'
      }
      if (key !== 'avatar') {
        style.color = s.color || '#333333'
        if (s.textAlign) style.textAlign = s.textAlign
        if (
          !(
            key === 'sendWord' ||
            key === 'significance' ||
            key === 'purposeBonus' ||
            key === 'motto'
          )
        ) {
          style.whiteSpace = 'pre-line'
        }
        const boldStage = this.getPosterBoldStage(key)
        style.fontWeight = boldStage
        if (key === 'NationalNum') {
          // 国赛号使用更接近号码牌的粗体数字风格
          // style.fontWeight = '900'
          // style.fontFamily = '"DIN Condensed", "Arial Narrow", "Arial Black", "Helvetica Neue", "PingFang SC", "Microsoft YaHei", sans-serif'
          style.fontFamily = 'Bahnschrift'
          // style.letterSpacing = '3px'
          style.lineHeight = '1'
          style.webkitTextStroke = '2px currentColor'
        }
      }
      if (key === 'avatar') {
        // 避免 html2canvas 对 transform: scale 渲染差异，直接把缩放折算到宽高
        const scale = s.scale != null ? Number(s.scale) : 1
        if (s.width) style.width = Math.max(1, Math.round(Number(s.width) * scale)) + 'px'
        if (s.height) style.height = Math.max(1, Math.round(Number(s.height) * scale)) + 'px'
      } else {
        if (s.width) style.width = s.width + 'px'
        if (s.height) style.height = s.height + 'px'
      }
      return style
    },
    getAvatarImageStyle () {
      const url = (this.posterFormData && this.posterFormData.avatar) || ''
      return {
        backgroundImage: `url('${url}')`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat'
      }
    },
    startDrag (e, key) {
      const s = this.posterTextStyles[key]
      if (!s) return
      const el = e.currentTarget
      if (!el) return
      this.posterDragState = {
        key,
        el,
        startX: e.clientX,
        startY: e.clientY,
        startLeft: s.left,
        startTop: s.top,
        lastLeft: s.left,
        lastTop: s.top
      }
      document.addEventListener('mousemove', this.onPosterDrag)
      document.addEventListener('mouseup', this.onPosterDragEnd)
    },
    onPosterDrag (e) {
      if (!this.posterDragState) return
      const { el, startX, startY, startLeft, startTop } = this.posterDragState
      const dx = e.clientX - startX
      const dy = e.clientY - startY
      const newLeft = Math.max(0, startLeft + dx)
      const newTop = Math.max(0, startTop + dy)
      this.posterDragState.lastLeft = newLeft
      this.posterDragState.lastTop = newTop
      el.style.left = newLeft + 'px'
      el.style.top = newTop + 'px'
    },
    onPosterDragEnd () {
      const state = this.posterDragState
      if (state) {
        const { key, lastLeft, lastTop, startLeft, startTop } = state
        if (key != null && lastLeft != null && lastTop != null) {
          const moved = (lastLeft !== startLeft || lastTop !== startTop)
          if (moved) {
            this.pushPosterUndoSnapshot()
            this.$set(this.posterTextStyles[key], 'left', lastLeft)
            this.$set(this.posterTextStyles[key], 'top', lastTop)
          }
        }
      }
      this.posterDragState = null
      document.removeEventListener('mousemove', this.onPosterDrag)
      document.removeEventListener('mouseup', this.onPosterDragEnd)
    },
    onPosterColorChange (key, value) {
      if (key && this.posterTextStyles[key]) {
        this.pushPosterUndoSnapshot()
        this.$set(this.posterTextStyles[key], 'color', value)
      }
    },
    closePosterDialog () {
      this.selectedPosterKey = null
      this.onPosterDragEnd()
    },
    downloadPosterImage () {
      const box = document.getElementById('posterExportBox')
      if (!box) {
        this.$message.error('未找到海报区域')
        return
      }
      this.$message.info('正在生成图片...')
      this.isExportingPoster = true
      this.$nextTick(() => {
        html2canvas(box, {
          scale: 2,
          useCORS: true,
          allowTaint: true,
          backgroundColor: null,
          logging: false
        }).then(canvas => {
          const url = canvas.toDataURL('image/png', 1)
          const link = document.createElement('a')
          link.href = url
          link.download = `选手手册_${(this.posterFormData && this.posterFormData.userName) || '海报'}_${Date.now()}.png`
          document.body.appendChild(link)
          link.click()
          document.body.removeChild(link)
          this.$message.success('海报已下载')
        }).catch(err => {
          console.error('html2canvas err', err)
          this.$message.error('生成图片失败')
        }).finally(() => {
          this.isExportingPoster = false
        })
      })
    }
  }
}
</script>

<style lang="less" scoped>
/* 选手手册海报弹窗样式 */
.poster-manual-dialog {
  ::v-deep .el-dialog__body {
    padding: 8px 12px 12px;
    max-height: calc(100vh - 130px);
    overflow-y: auto;
    box-sizing: border-box;
  }
  ::v-deep .el-dialog__footer {
    padding: 10px 16px 14px;
  }
  ::v-deep .el-dialog__footer .dialog-footer {
    display: flex;
    flex-wrap: nowrap;
    justify-content: flex-end;
    align-items: center;
    gap: 8px;
    flex-shrink: 0;
  }
  .poster-toolbar {
    margin-bottom: 12px;
    padding: 8px 12px;
    background: #f5f7fa;
    border-radius: 4px;
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    .toolbar-label {
      margin-right: 8px;
      font-size: 14px;
    }
    .toolbar-value {
      margin-left: 8px;
      font-size: 13px;
      color: #606266;
    }
    &.poster-toolbar-text {
      align-items: flex-start;
      .poster-edit-content-wrap {
        width: 100%;
        margin-top: 10px;
        padding-top: 8px;
        border-top: 1px dashed #dcdfe6;
        .toolbar-label {
          display: block;
          margin-bottom: 6px;
        }
      }
      .poster-content-textarea {
        width: 100%;
        max-width: 400px;
      }
      .poster-age-grade-tip {
        border-top: none;
        padding-top: 0;
        margin-top: 6px;
        .toolbar-label {
          font-size: 12px;
          color: #909399;
        }
      }
    }
    .poster-color-input {
      width: 36px;
      height: 28px;
      padding: 2px;
      border: 1px solid #dcdfe6;
      border-radius: 4px;
      cursor: pointer;
      vertical-align: middle;
      background: #fff;
    }
  }
  .poster-wrap {
    overflow: hidden;
    display: flex;
    justify-content: center;
    align-items: flex-start;
    background: #e8e8e8;
    padding: 10px 8px;
  }
  .poster-viewport {
    position: relative;
    flex-shrink: 0;
    margin: 0 auto;
  }
  .poster-scale-inner {
    position: absolute;
    left: 0;
    top: 0;
  }
  .poster-canvas-box {
    position: relative;
    flex-shrink: 0;
    box-shadow: 0 2px 12px rgba(0, 0, 0, 0.15);
    .poster-bg {
      position: absolute;
      left: 0;
      top: 0;
      width: 100%;
      height: 100%;
      object-fit: fill;
      display: block;
      pointer-events: none;
    }
    .poster-item {
      position: absolute;
      cursor: move;
      user-select: none;
      pointer-events: auto;
      box-sizing: border-box;
    }
    .poster-avatar {
      border-radius: 40px;
      overflow: hidden;
      // border: 4px solid #c9a227;
      box-shadow: 0 2px 8px rgba(0, 0, 0, 0.2);
      .avatar-img {
        width: 100%;
        height: 100%;
        display: block;
      }
    }
    .poster-text {
      color: #333;
      font-weight: 500;
      max-width: 350px;
      line-height: 1.4;
      word-break: break-all;
    }
    .poster-national-num {
      font-weight: bold;
      color: #000;
    }
    .poster-yellow {
      color: #333;
    }
    .poster-item.selected {
      outline: 2px solid #409eff;
      outline-offset: 2px;
      z-index: 10;
    }
  }
}
</style>
